module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Dishes-c9b13595e642ea059882bd6064476d24.svg";